import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

const Layout = () => (
  <div className="min-h-screen bg-slate-100 flex">
    <Sidebar />
    <div className="flex-1 flex flex-col min-w-0">
      <main className="flex-1 p-6 lg:p-8 overflow-auto">
        <Outlet />
      </main>
    </div>
  </div>
);

export default Layout;
